import format from 'date-fns/format';

import { MessageTypes } from 'src/store/types';
import cn from 'classnames';
import './styles.scss';
import { DOWNLOAD_PATH } from '../../../../../../../../constants';
import { MessageButtons } from './components/MessageButtons';
import Linkify from 'linkify-react';
import PostageSendButton from '../PostageSendButton';

type Props = {
  message: MessageTypes;
  showTimeStamp: boolean;
  sendMessage: (message: string) => void;
}

const getDownloadURI = (fileName: string) => {
  return DOWNLOAD_PATH + fileName
}

function Message({ message, showTimeStamp, sendMessage }: Props) {
  const isClient = message.sender === 'client'

  const isSending = !message.acknowledged && !message.error
  // Transform /start command to display message
  const displayText = isClient && message.text === '/start'
    ? 'Вы нажали начать новый диалог'
    : message.text;


  return (
    <>
      <div className={`rcw-${message.sender}`}>

        <div className={cn("rcw-message-text", { 'rcw-message-text-sending': isSending })}>
          <span className="rcw-message-text-wrapper">
            {/* @ts-ignore */}
            <Linkify options={{ target: '__blank' }}>{displayText}</Linkify>
            {message?.files && message.files.map(el =>
              <div className='rcw-message-link-wrapper'>
                <a className='rcw-message-link' href={getDownloadURI(el)}>{el}</a>
              </div>)}

          </span>
          <div className='rcw-message-text-footer'>
            {message.error ?
              <>
                <span className='rcw-message-text-error'>Ошибка отправки</span>
                <PostageSendButton message={message} />
              </> :
              <>
                <div className="rcw-sender-name">{message.senderName || ''}</div>
                {showTimeStamp && <div className="rcw-timestamp"><span>{format(message.timestamp, 'HH:mm')}</span></div>}
              </>
            }

          </div>

        </div>
      </div>
      {!isClient && (
        <MessageButtons
          sendMessage={sendMessage}
          buttons={message?.buttons || []}
        />
      )}
    </>
  );
}

export default Message;
